module.exports = __webpack_public_path__ + "media/warranty-claim/photos-front-house-a8c5be1b.png";